import { axiosClient } from '@shared/data-access';
import Compressor from 'compressorjs';

export const renameFile = (originalFile, newName) =>
  new File([originalFile], newName, {
    type: originalFile?.type,
    lastModified: originalFile?.lastModified,
  });

export const uploadFile = async (file: File, url: string, FileUploadedStatus) => {
  try {
    const onUploadProgress = (event) => {
      const percentCompleted = Math.round((event?.loaded * 100) / event?.total);
      if (percentCompleted) FileUploadedStatus(percentCompleted);
    };

    await axiosClient.put(url, file, {
      onUploadProgress,
      headers: {
        'Content-Type': file.type,
      },
    });
  } catch (err) {
    console.log(err);
  }
};

const IMAGE_QUALITY = 0.85;
const MAX_IMAGE_WIDTH = 1200;

export const compressFile = (
  image: File,
  handleCompressedFile: (image: File) => void,
  onError?: (error: Error) => void
) => {
  new Compressor(image, {
    quality: IMAGE_QUALITY,
    maxWidth: MAX_IMAGE_WIDTH,
    success: handleCompressedFile,
    error(err) {
      onError && onError(err);
      console.log('File compress error', err.message);
    },
  });
};
